import { Box } from '@mui/material';
import { DevicesResponse, devicesTypes, DevicesTypeSelect, SelectedDeviceId } from '../types';
import BookingDeviceAccordion from './BookingDeviceAccordion';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';
import ModalErrorContainer from '@shared/components/modals/ModalErrorContainer';
import { getFullDeviceInfoReset } from '../store';
import { selectGetFullDeviceInfoErrorInfo, selectGetFullDeviceInfoStatus } from '../store/selectors';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { RequestStatusEnum } from '@shared/types';

export interface BookingCalendarDevicesListProps {
    devices: DevicesResponse | null;
    getDevicesStatus: RequestStatusEnum;
    devicesType: DevicesTypeSelect;
    selectedDeviceId: SelectedDeviceId;
    setSelectedDeviceId: (newSelectedDeviceId: SelectedDeviceId) => void;
}

const BookingCalendarDevicesList: FC<BookingCalendarDevicesListProps> = ({
    devices,
    getDevicesStatus,
    devicesType,
    selectedDeviceId,
    setSelectedDeviceId,
}) => {
    const { t } = useTranslation();
    const getFullDeviceInfoStatus: RequestStatusEnum = useSelector(selectGetFullDeviceInfoStatus);

    return (
        <Box sx={{ width: 336, overflowY: 'auto' }}>
            {devicesTypes
                .filter((dt) => {
                    if (!devicesType) {
                        return true;
                    }
                    return dt === devicesType;
                })
                .map((dt) => (
                    <BookingDeviceAccordion
                        key={dt}
                        devices={devices}
                        getDevicesStatus={getDevicesStatus}
                        devicesType={dt}
                        selectedDeviceId={selectedDeviceId}
                        setSelectedDeviceId={setSelectedDeviceId}
                    />
                ))}
            {getFullDeviceInfoStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('device_info_r')}
                    action={t('fetching')}
                    resetActionCallback={getFullDeviceInfoReset}
                    errorSelector={selectGetFullDeviceInfoErrorInfo}
                />
            )}
        </Box>
    );
};

export default BookingCalendarDevicesList;
